/**
 * Created by andrewstirling on 21/12/16.
 */

import React, { Component } from 'react';
import CustomerIntegrations from '../presentation/customer-integrations';

export default class CustomerInformationWidget extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    toggleSalesforceActive = () => {
        if( this.props.customer.integrations.salesforceMC.activated ) {
            if(confirm("Are you sure you want to proceed with deactivating this account's Salesforce Marketing Cloud integration?")) {
                fetch("/service/deactivateSalesforce", {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${localStorage.getItem('idToken')}`
                    },
                    credentials: 'same-origin',
                    body: JSON.stringify({customerId: this.props.customer._id})
                }).then(response => {
                    if (response.status != 200) {
                        response.json().then(json => {
                            this.handleError(json, this);
                            return;
                        });
                    } else {
                        response.json().then(json => {
                            this.updateCustomer(json.customer);
                        });
                    }
                });
            }
        } else {
            if(confirm("Are you sure you want to proceed with the activation this account's Salesforce Marketing Cloud integration?")) {
                fetch("/service/activateSalesforce", {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${localStorage.getItem('idToken')}`
                    },
                    credentials: 'same-origin',
                    body: JSON.stringify({customerId: this.props.customer._id})
                }).then(response => {
                    if (response.status != 200) {
                        response.json().then(json => {
                            this.handleError(json, this);
                            return;
                        });
                    } else {
                        response.json().then(json => {
                            this.updateCustomer(json.customer);
                        });
                    }
                });
            }
        }
    };

    updateCustomer = customer => {
        this.props.refreshCustomer(customer);
    };

    render() {
        return <CustomerIntegrations customer={this.props.customer} toggleSalesforceActive={this.toggleSalesforceActive} />
    }
}